import type { ErrorComponentProps } from '@tanstack/react-router';

import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '../components/ui/dialog';
import { useIsAdminViewer } from '../hooks/use-is-admin-viewer';

export const BUG_REPORT_URL = 'https://protective-smile-58c.notion.site/ebd//29e9f5e7afa246bda10f6d3244ac6bec';

const buttonClass = 'px-6 py-3 rounded-sm font-black shadow-card cursor-pointer min-h-[44px]';

export default function ErrorScreen({ error }: ErrorComponentProps) {
  const isAdmin = useIsAdminViewer();

  return (
    <main className="min-h-screen grid place-items-center p-6 text-center">
      <div className="max-w-[640px] w-full">
        <h1 className="text-3xl font-black text-[var(--naia-text-primary)]">Oups, cette page a rencontré un problème</h1>
        <p className="mt-3 text-base text-[var(--naia-text-secondary)]">
          Vous pouvez réessayer ou nous signaler le problème afin que nous puissions le corriger.
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-3">
          <button type="button" onClick={() => window.location.reload()} className={`${buttonClass} bg-naia-blue text-card border-none`}>
            Réessayer
          </button>
          <Dialog>
            <DialogTrigger className={`${buttonClass} bg-transparent text-[var(--naia-text-primary)] border border-solid border-[var(--naia-text-secondary)]`}>
              Signaler le problème
            </DialogTrigger>
            <DialogContent style={{ height: '80vh' }}>
              <DialogHeader>
                <DialogTitle>Signaler un bug</DialogTitle>
              </DialogHeader>
              <iframe
                src={BUG_REPORT_URL}
                style={{ width: '100%', flexGrow: 1, border: 'none', borderRadius: '0 0 var(--naia-r-md) var(--naia-r-md)' }}
                title="Formulaire de remontée de bug"
                allow="clipboard-write"
              />
            </DialogContent>
          </Dialog>
        </div>
        <p className="mt-6 text-xs text-[var(--naia-text-secondary)]">
          Page : {window.location.pathname}
          {` · v ${__BUILD_HASH__}`}
        </p>
        {isAdmin && (
          <details className="mt-4 text-left" open>
            <summary className="cursor-pointer text-sm font-bold text-[var(--naia-text-primary)]">Détails techniques (admin)</summary>
            <pre className="mt-2 p-3 overflow-auto text-xs font-mono whitespace-pre-wrap break-words rounded-sm border border-solid border-[var(--naia-text-secondary)] text-[var(--naia-text-primary)]">
              {error.message}
              {error.stack ? `\n\n${error.stack}` : ''}
            </pre>
          </details>
        )}
      </div>
    </main>
  );
}
